import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

class ContractService {
  getYears() {
    return instance.get("/get-years");
  }
  getCheckNo3Years(param) {
    return instance.get("/get-check-no3years/" + param);
  }
  importYears(body) {
    return instance.post("/import-years", body);
  }
  deleteYears(body) {
    return instance.post("/delete-years", body);
  }
  getContracts(body) {
    return instance.post("/get-contracts", body);
  }
  getContractByID(body) {
    return instance.post("/get-contracts-by-thai-no", body);
  }
}

export default new ContractService();
